<template>
  <div class="identity">
    <van-nav-bar title="迪夫康复" class="main-nav" @click-left="onClickLeft" />
    <div class="identity">
      <h1>欢迎来到，迪夫康复</h1>
      <div class="parent" @click.stop="jumpToInfor(1)">
        <span>我是家长</span>
        <img :src="arrowPic" alt="" />
      </div>
      <div class="child" @click.stop="jumpToInfor(2)">
        <span>我是专业人士</span>
        <img :src="arrowPic" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      arrowPic: require("../../assets/images/login/arrow.png"),
    };
  },
  methods: {
    onClickLeft() {
      // this.$router.push("/login");
    },
    jumpToInfor(type) {
      this.$router.push({
        path: "/information",
        query: {
          registryType: type,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.identity {
  background: url(../../assets/images/login/bg.png) no-repeat left top/100%
    331px;
  padding-bottom: 10px;
  h1 {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #2e4344;
    line-height: 25px;
    margin: 24px 0 24px 32px;
  }
  .parent,
  .child {
    margin: 0 auto;
    width: 335px;
    height: 120px;
    box-sizing: border-box;
    padding-left: 26px;
    background: url(../../assets/images/login/parent.png) no-repeat left
      top/cover;
    display: flex;
    align-items: center;
    span {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2e4344;
    }
    img {
      width: 22px;
    }
  }
  .child {
    background-image: url(../../assets/images/login/child.png);
  }
  .parent {
    margin-bottom: 16px;
  }
}
</style>
